import { taskFileThumbnailTypeDef } from "./task-file-thumbnail-type-def";

export const taskFileTypeDef = `
    id
    taskId
    taskFileGroupId
    name
    size
    extension
    createdAt
    updatedAt
    removedAt
    type
    src
    optimizedFile {
      src
      extension
    }
    thumbnails {
      ${taskFileThumbnailTypeDef}
    }
`;
